module.exports = __webpack_public_path__ + "img/login-img.6abbb3f8.jpg";